import script from "./changeEmit.vue?vue&type=script&lang=js"
export * from "./changeEmit.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__